import { Actions, ArrowPathIcon, Badge, Tooltip } from "@";

export const TableActions = ({
  row,
  deleteHandler,
  handelResendSingle,
  isSmsBalanceLow,
}) => {
  return (
    <>
      <Actions delete={deleteHandler} notEdit notShow row={row} />
      {!row.isSent && !isSmsBalanceLow && (
        <>
          <span
            onClick={() => handelResendSingle(row.id)}
            data-tooltip-placement="right"
            className="icon-style cursor-pointer"
            data-tooltip-target={`action-z-${row.id}`}
          >
            <ArrowPathIcon className="w-6" />
          </span>
          <Tooltip title=" إعادة الارسال" id={`action-z-${row.id}`} />
        </>
      )}
    </>
  );
};

export const tableColumns = [
  {
    name: "تاريخ الارسال",
    selector: ({ sendingDate }) => sendingDate,
  },
  {
    name: "محتوى الرسالة",
    selector: ({ body }) => body,
  },
  {
    name: "مستقبل الرسالة",
    cell: ({ reipientDisplayName, recipientPhoneNumber }) => (
      <div>
        <p>{reipientDisplayName}</p>
        <p>{recipientPhoneNumber}</p>
      </div>
    ),
  },
  {
    name: "حالة الارسال",
    cell: ({ isSent }) => (
      <Badge
        title={isSent ? " تم الارسال" : " لم يتم الارسال"}
        color={isSent ? "green" : "red"}
      />
    ),
  },
];
